import api from './axiosService';

export const financialRecordApi = {
    getAll(params = {}) {
        return api.get('/financial-records', { params });
    },

    getById(financialId) {
        return api.get(`/financial-records/${financialId}`);
    },

    getByShop(shopId) {
        return api.get(`/financial-records/shop/${shopId}`);
    },

    getAllByShop(shopId, params = {}) {
        return api.get(`/financial-records/shop/${shopId}`, { params });
    },

    getTotalByShop(shopId) {
        return api.get(`/financial-records/shop/${shopId}/total`);
    },

    getTransactionsByShop(shopId, params = {}) {
        return api.get(`/financial-records/shop/${shopId}/transactions`, { params });
    },

    create(data) {
        return api.post('/financial-records', data);
    },

    update(financialId, data) {
        return api.put(`/financial-records/${financialId}`, data);
    },

    toggleStatus(financialId) {
        return api.patch(`/financial-records/${financialId}/toggle-status`);
    },
};